function Const() {
    return {
        NET: {
            URL_POINT: 'http://api.eventhub.rebuildsoft.com/admin/1',
            URL_POINT_DEV: 'http://api.eventhub.rebuildsoft.com/admin/1',
            // URL_POINT_DEV: 'http://192.168.3.17:8073/admin/1',
            IMG_URL: 'http://rebuildsoft-smartwork.oss-cn-hangzhou.aliyuncs.com/img/',
            FILE_URL_PREFIX: '',

            PROJECT_FILE_END_POINT:'',
            FILE_UPLOAD_END_POINT: '',
            IMG_UPLOAD_END_POINT: '',
        },
        DATA: {
            KEY_PREFIX: 'eventhub.data.',
            KEY_TOKEN: 'eventhub.token',
            KEY_USER: 'eventhub.user',
        },
    }
}

export default new Const()
